import { render, staticRenderFns } from "./add-link-item.vue?vue&type=template&id=8409c548&scoped=true&"
import script from "./add-link-item.vue?vue&type=script&lang=js&"
export * from "./add-link-item.vue?vue&type=script&lang=js&"
import style0 from "./add-link-item.vue?vue&type=style&index=0&id=8409c548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8409c548",
  null
  
)

export default component.exports